import type {View, ViewColProps, ViewProps} from "./View";
import type {ColType, Column} from "@t/agenda/Columns";

export interface Options {
	[key: string] : any
}

export interface AgendaData<T> {
    total: number;
    position: number;
    size: number;
    orderBy?: string;
    desc?: boolean;
    items: T[];
	/** Extra data which can be packed in */
	meta?: Options;
}

export interface AgendaClass {
	/** Agenda class name */
	agenda: string;
	/** Entity class name */
	entity?: string;
}

export interface Agenda extends AgendaClass{
    /** Saved view ID */
    id?: number;
    view: View
}


export interface AgendaReference extends AgendaClass {
    view: ViewColProps
}

export interface AgendaRegistryEntry extends AgendaReference {
    name: string;
	/** Type of column containing reference to this agenda */
    type?: ColType;
    references?: AgendaReference[];
}

export interface AgendaDescriptor extends AgendaClass {
    props?: ViewProps;
}

export function referenceToDescriptor(ref: AgendaReference): AgendaDescriptor {
	const desc: AgendaDescriptor = {
		agenda: ref.agenda,
	};
	if (ref.entity) desc.entity = ref.entity;
	if (ref.view && ref.view.props) {
		desc.props = { ...ref.view.props };
	}
	return desc;
}

/**
 * Agenda metadata obtained using META http method from an endpoint.
 * This is the way how grid-like components can access info about fetched agenda
 */
export interface AgendaMeta {
	/** Defines column layout, filtering and sorting */
	view: View;

	/** if positive number, agenda will be paginated with page size set to this value (paginated agenda doesn't support reordering) */
	page?: number;
	/** Zero-based index of the first row on the page */
	position?: number;

	/** Required for filtering (provide to enable filter editting) */
	descriptor?: AgendaDescriptor;

	/** The endpoint supports QUERY method */
	allowedQuery?: boolean;

	/** List of all available columns */
	allColumns: Column[];
}